import { ColumnDimension } from "@components/common/data-grid/adm-data-grid-types";
import {
  TESTING_IMPERSONATION_TABLE_COLUMN_LABELS,
  TestingImpersonationTableColumnField,
  TestingImpersonationTableGridColDef,
} from "@pages/testing-impersonation/testing-impersonation-table-types";
import {
  TestingImpersonationDescriptionCell,
  TestingImpersonationNameAndEmailCell,
  TestingImpersonationLoginLinkCell,
} from "@utils/data-grid-utils/testing-impersonation-data-grid-cells";
import { useMemo } from "react";

const columnDimension: ColumnDimension<TestingImpersonationTableColumnField> = {
  nameAndEmail: {
    flex: 1.5,
  },
  description: {
    flex: 2,
  },
  loginLink: {
    flex: 1,
  },
};

/**
 * @param numberedEnv The selected numbered environment (e.g. "dev15") used to
 * build the impersonation redirect link
 * @returns the columns definition to be used in the testing impersonation table
 */
export function useTestingImpersonationTableColumns(
  numberedEnv: string
): TestingImpersonationTableGridColDef[] {
  return useMemo(() => {
    const columnsMap: Record<
      TestingImpersonationTableColumnField,
      TestingImpersonationTableGridColDef
    > = {
      nameAndEmail: {
        field: "nameAndEmail",
        headerName: TESTING_IMPERSONATION_TABLE_COLUMN_LABELS.nameAndEmail,
        ...columnDimension.nameAndEmail,
        valueGetter: (_, row) => `${row.entity.name} ${row.entity.email}`,
        renderCell: TestingImpersonationNameAndEmailCell,
      },

      description: {
        field: "description",
        headerName: TESTING_IMPERSONATION_TABLE_COLUMN_LABELS.description,
        ...columnDimension.description,
        valueGetter: (_, row) => row.entity.description,
        renderCell: TestingImpersonationDescriptionCell,
      },

      loginLink: {
        field: "loginLink",
        headerName: TESTING_IMPERSONATION_TABLE_COLUMN_LABELS.loginLink,
        ...columnDimension.loginLink,
        getApplyQuickFilterFn: () => null,
        renderCell: (params) =>
          TestingImpersonationLoginLinkCell(params, numberedEnv),
      },
    };
    return Object.values(columnsMap);
  }, [numberedEnv]);
}
